import React from 'react';

import Container from '@src/components/Container';
import PostCard from '@src/components/PostCard';
import RefreshControl from '@src/components/RefreshControl';
import VisibleStatusBar from '@src/components/VisibleStatusBar';
import useAnimatedHeader from '@src/hooks/useAnimatedHeader';
import usePosts from '@src/hooks/usePosts';
import useViewableItems from '@src/hooks/useViewableItems';

import { List } from './styled';
import { Props } from './types';

const Screen: React.FC<Props> = ({
  navigation,
  route: {
    params: { url, params, title },
  },
}) => {
  const posts = usePosts(url, params);
  const handleScroll = useAnimatedHeader();
  const {
    handleViewableItemsChanged,
    currentVisibleIndex,
    viewabilityConfig,
  } = useViewableItems();

  React.useLayoutEffect(() => {
    navigation.setOptions({
      title,
      headerTitle: title,
    });
  }, [navigation, title]);

  return (
    <>
      <VisibleStatusBar />
      <Container>
        <List
          onScroll={handleScroll}
          data={posts.data}
          onViewableItemsChanged={handleViewableItemsChanged}
          viewabilityConfig={viewabilityConfig}
          refreshControl={
            <RefreshControl
              refreshing={posts.refreshing}
              onRefresh={posts.handleRefresh}
            />
          }
          onEndReached={posts.handleEndReached}
          renderItem={({ item, index }) => (
            <PostCard data={item} play={index === currentVisibleIndex} />
          )}
        />
      </Container>
    </>
  );
};

Screen.displayName = 'Posts';

export default Screen;
